import { render, staticRenderFns } from "./AccountQuestion.vue?vue&type=template&id=0429beaa"
import script from "./AccountQuestion.vue?vue&type=script&lang=js"
export * from "./AccountQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports